import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders } from '@angular/core';
import { MetConfig } from './met-config';
import { MeteoriteCartComponent } from './cart/meteorite-cart.component';
import { MeteoriteSharedModule } from 'meteorite-shared';
import { MeteoriteCmsModule } from 'meteorite-cms';
import { TotalsComponent } from './totals/totals.component';



@NgModule({
  declarations: [
    MeteoriteCartComponent,
    TotalsComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    MeteoriteSharedModule,
    MeteoriteCmsModule
  ],
  exports: [MeteoriteCartComponent]
})
export class MeteoriteCartModule {

  static initClientData(metConfig: MetConfig): ModuleWithProviders<MeteoriteCartModule> {
    return {
      ngModule: MeteoriteCartModule,
      providers: [
        {
          provide: MetConfig,
          useValue: metConfig,
        },
      ],
    };
  }

}
